/*
 * @Author: summer
 * @Date: 2019-08-12 09:48:09
 * @LastEditTime: 2019-08-12 09:53:35
 * @LastEditors: Do not edit
 */
/* eslint-disable no-console */
import React, { Component } from 'react';
// import FormControl from '../-FormControl';
import Refer from './index';
// FormControl.fakeRefer = 'fakeRefer';
export default class ReferLoader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			refer: null
		};
	}

	componentDidMount() {
		this.createScript(this.props.refcode);
	}

	//WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
	componentWillReceiveProps(nextProps) {
		if (this.props.refcode !== nextProps.refcode) {
			this.createScript(nextProps.refcode);
		}
	}

	componentWillUnmount() {
		// 移除事件监听
		if (this.script) {
			this.script.removeEventListener('load', this.a);
			this.script.removeEventListener('error', this.b);
			delete this.a;
			delete this.b;
			delete this.script;
		}
	}

	refCodeToRefKey = (refcode) => {
		var s = refcode.split('/'),
			refKey;
		refKey = s.slice(s.length - 5).join('/');
		refKey.includes('.js') && (refKey = refKey.substring(0, refKey.length - 3));
		return refKey;
	};

	createScript = (src) => {

		if (src) {
			var that = this,
				scripts = Array.from(document.getElementsByTagName('script')),
				flag,
				refKey = this.refCodeToRefKey(src);
			flag = scripts.find((e) => {
				return e.src.includes(refKey);
			});
			this.a = this.handleLoad.bind(null, refKey, true);
			this.b = this.handError.bind(null, src);
			if (window[refKey]) {
				// 已经加载过script标签
				this.handleLoad(refKey);
			} else {
				this.setState(
					{
						refer: null
					},
					() => {
						let script;
						if (flag) {
							script = flag;
						} else {
							script = document.createElement('script');
							script.src = '../../../../' + refKey + '.js';
							script.type = 'text/javascript';
							document.body.appendChild(script);
						}
						this.script = script;
						script.addEventListener('load', this.a);
						script.addEventListener('error', this.b);
					}
				);
			}
		}
	};

	handError = (src) => {
		console.error(`找不到${src}这个文件，请检查引用路径`);
	}

	handleLoad = (refKey, async = false) => {
		let that = this;
		try {
			if (!(async && refKey !== that.refCodeToRefKey(that.props.refcode))) {
				that.setState({
					refer: window[refKey].default
				});
			}
		} catch (e) {
			console.error(e.message);
			console.error(`请检查引用的${that.props.refcode}这个文件是源码还是编译好的。源码需要在config.json/buildEntryPath配相应的路径，编译好的则不用`);
		}
	};

	render() {
		let App = this.state.refer;
		let { multiplelines, refenter, ...others } = this.props;

		// if (multiplelines) {
		// 	others.inputType = 'textarea';
		// }
		if (refenter) {
			others.checkStrictly = false;
		}

		if (others.refcode) {
			return typeof App === 'function' && <App {...others} />;
		} else {
			return <Refer {...others} />;
		}
	}
}
